<template>
    <div>
        <timeline :time-line-items="steps" :active-index="0">
            <template v-slot:form>
                <Card class="mb-12">
                    <template v-slot:title>{{ __('general.stores_sum') }}</template>

                    <div class="d-flex flex-row text-lg gap-10 align-items-center">
                        <div>{{ storeCount }}</div>
                        <div class="text-muted">{{ __('user.stores') }}</div>
                        <a :href="$route('account-setup-store-count.show')" class="btn btn-primary"><i
                            class="fas mr-1 fa-pen"></i>{{ __('general.edit') }}</a>
                    </div>
                </Card>

                <!--            Bundle -->
                <Card class="mb-12">
                    <template v-slot:title>{{ __('general.plan') }}</template>
                    <div class="row">
                        <div v-for="(bundle, index) in bundles"
                             class="col-lg-6">
                            <label @click="setBundleAndPricingGroup(bundle, index)" class="option"
                                   :class="{'border-primary' : form.bundle_id === bundle.id}">
                              <span class="option-control">
                                <span class="radio">
                                    <input type="radio"
                                           :checked="form.bundle_id === bundle.id"/>
                                <span></span>
                                </span>
                              </span>
                                <span class="option-label">
                                    <span class="option-head">
                                        <span class="option-title">{{ getTranslation(bundle.lang.name) }}</span>

                               </span>
                               <span class="option-body">
                                   <Price class="text-2xl text-primary" :value="bundle.pricing_groups.flex[0].value" :currency="bundle.pricing_groups.flex[0].currency"></Price>
                                   <span class="text-lg">{{ __('account-setup.per_month_and_store') }}</span>
                               </span>
                            </span>
                            </label>
                        </div>
                    </div>
                    <span class="invalid-feedback d-inline" v-if="form.errors.bundle">{{
                            form.errors.bundle
                        }}</span>
                </Card>

                <!--        Features        -->
                <div class="card card-custom">
                    <div class="card-header">
                        <div class="card-title row w-100">
                            <div class="col-6">{{__('general.channels') }}</div>
                            <div class="col-6">{{ __('subscriptions.transaction_fees') }}</div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-for="feature in allBundleFeatures" class="row mb-12">
                            <div class="col-6">
                                <div class="checkbox-inline">
                                    <label class="checkbox checkbox-primary">
                                        <input type="checkbox" :checked="(Object.values(selectedBundle.features).find((item) => item.id === feature.id)) !== undefined" disabled>
                                        <span></span>{{ getTranslation(feature.lang.name) || 'Unknown product' }}
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="Object.keys(feature.pricing_groups).length > 0"
                                class="col-6">
                                {{ feature.pricing_groups.flex[0].value }} % {{ __('account-setup.per_transaction') }}
                            </div>
                            <div v-else class="col-6">{{ __('account-setup.no_fees') }}</div>
                        </div>
                        <span class="text-muted">{{ __('account-setup.one_price_channels') }}</span>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-20">
                    <button @click="previousStep" class="mr-auto py-4 btn btn-secondary">
                        <i class="fas fa-arrow-circle-left mr-3"></i>{{__('actions.back') }}
                    </button>
                    <button @click="submit()" class="btn btn-primary">
                        {{__('actions.next') }}<i class="fas fa-arrow-circle-right ml-3"></i>
                    </button>
                </div>

            </template>
        </timeline>
    </div>
</template>

<script>
import AccountSetupLayout from '@layouts/AccountSetupLayout';
import Timeline from '@components/Timeline';
import Price from '@components/Price';
import Card from '@components/Cards/Card';
import helperMethods from '@mixins/helperMethods'

export default {
    mixins: [helperMethods],
    name: 'Features',
    components: {Card, Price, Timeline},
    layout: AccountSetupLayout,

    props: {
        steps: Object,
        bundles: Array,
        storeCount: Number,
        allBundleFeatures: Array,
        savedBundle: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                bundle_id: null,
                pricing_group: "flex",
                features: [],
                local: this.$lang.locale
            }),
            selectedBundle: null,
        };
    },

    mounted() {
        if (!_.isEmpty(this.savedBundle)) {
            this.setBundleAndPricingGroup(this.savedBundle);
        } else {
            this.setBundleAndPricingGroup(this.bundles[0]);
        }
    },

    methods: {
        previousStep() {
            this.$inertia.get(this.$route('account-setup.show'));
        },

        submit() {
            this.form.post(this.$route('account-setup-features.update'), {
                preserveState: true,
                preserveScroll: true,
                onError: (errors) => {
                    toastr.error(__('general.error_check_data'));
                },
                onSuccess:() => {
                    toastr.success(__('account-setup.thing.success', {thing: __('account-setup.plan_and_channels')}))
                }
            });
        },

        setBundleAndPricingGroup(bundle) {
            this.form.bundle_id = bundle.id;
            this.selectedBundle = bundle;
            this.form.features = []

            bundle.features.forEach(feature => {
                this.form.features.push(feature.id);
            });
        },
    },
};
</script>
